import moment from 'moment';
import Immutable from 'immutable';
import {
  SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
  SUBSCRIPTION_PLAN_TYPE_PORTAL,
  SUBSCRIPTION_PLAN_STATUS_TRIAL,
  SUBSCRIPTION_PLAN_STATUS_ACTIVE,
  SUBSCRIPTION_PLAN_STATUS_PAST_DUE,
  SUBSCRIPTION_PLAN_STATUS_EXPIRED,
  SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING,
  SUBSCRIPTION_PLAN_STATUS_CANCELLED,
  SUBSCRIPTION_PLAN_BILLING_METHOD_NONE,
  SUBSCRIPTION_PLAN_BILLING_METHOD_INVOICE,
  SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
  SUBSCRIPTION_PLAN_ACTION_UPGRADE_EDUCATOR,
  SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD,
  SUBSCRIPTION_PLAN_ACTION_CANCEL,
  SUBSCRIPTION_PLAN_ACTION_CANCEL_EDUCATOR,
  SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_EDUCATOR,
  SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_TEACHCOMAU,
} from './constants';

export const validUserSubscriptionPlanSettings = Immutable.fromJS({
  [SUBSCRIPTION_PLAN_TYPE_EDUCATOR]: {
    [SUBSCRIPTION_PLAN_STATUS_TRIAL]: {
      [SUBSCRIPTION_PLAN_BILLING_METHOD_NONE]: {
        description: 'Educator trial',
        hasExpiryDate: true,
        showExpiryDate: true,
        hasNextPaymentDate: false,
        showNextPaymentDate: false,
        showAmount: true,
        showPaymentMethod: false,
        actions: [
          {
            action: SUBSCRIPTION_PLAN_ACTION_UPGRADE_EDUCATOR,
            contactCS: false,
          },
        ],
      },
    },
    [SUBSCRIPTION_PLAN_STATUS_ACTIVE]: {
      [SUBSCRIPTION_PLAN_BILLING_METHOD_INVOICE]: {
        description: 'Manually invoiced educator subscription',
        hasExpiryDate: true,
        showExpiryDate: true,
        hasNextPaymentDate: false,
        showNextPaymentDate: false,
        showAmount: true,
        showPaymentMethod: true,
        actions: [
          {
            action: SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD,
            contactCS: true,
          },
          {
            action: SUBSCRIPTION_PLAN_ACTION_CANCEL,
            contactCS: true,
          },
        ],
      },
      [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
        description: '`Active` braintree educator subscription',
        hasExpiryDate: true,
        showExpiryDate: false,
        hasNextPaymentDate: true,
        showNextPaymentDate: true,
        showAmount: true,
        showPaymentMethod: true,
        actions: [
          {
            action: SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD,
            contactCS: false,
          },
          {
            action: SUBSCRIPTION_PLAN_ACTION_CANCEL_EDUCATOR,
            contactCS: false,
          },
        ],
      },
    },
    [SUBSCRIPTION_PLAN_STATUS_PAST_DUE]: {
      [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
        description:
          '`Past Due` braintree educator subscription; Payment has been declined but subscription is still within Braintree recurring billing options automatic retry period of 7 days',
        hasExpiryDate: true,
        showExpiryDate: false,
        hasNextPaymentDate: true,
        showNextPaymentDate: true,
        showAmount: true,
        showPaymentMethod: true,
        actions: [
          {
            action: SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD,
            contactCS: false,
          },
          {
            action: SUBSCRIPTION_PLAN_ACTION_CANCEL_EDUCATOR,
            contactCS: false,
          },
        ],
      },
    },
    [SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING]: {
      [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
        description:
          'Educator subscription marked for cancellation at the end of current billing cycle; could have been cancelled by user or by CS via braintree',
        hasExpiryDate: true,
        showExpiryDate: true,
        hasNextPaymentDate: false,
        showNextPaymentDate: false,
        showAmount: false,
        showPaymentMethod: false,
        actions: [],
      },
    },
    [SUBSCRIPTION_PLAN_STATUS_CANCELLED]: {
      [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
        description: '`Canceled` braintree educator subscription',
        hasExpiryDate: true,
        showExpiryDate: true,
        hasNextPaymentDate: false,
        showNextPaymentDate: false,
        showAmount: false,
        showPaymentMethod: false,
        actions: [
          {
            action: SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_EDUCATOR,
            contactCS: false,
          },
        ],
      },
    },
    [SUBSCRIPTION_PLAN_STATUS_EXPIRED]: {
      [SUBSCRIPTION_PLAN_BILLING_METHOD_NONE]: {
        description: 'Expired educator trial',
        hasExpiryDate: true,
        showExpiryDate: true,
        hasNextPaymentDate: false,
        showNextPaymentDate: false,
        showAmount: false,
        showPaymentMethod: false,
        actions: [
          {
            action: SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_EDUCATOR,
            contactCS: false,
          },
        ],
      },
    },
  },
  [SUBSCRIPTION_PLAN_TYPE_PORTAL]: {
    teachcomau: {
      [SUBSCRIPTION_PLAN_STATUS_ACTIVE]: {
        // Note: Invoiced teach.com.au subscriptions are managed manually outside of the system
        [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
          description: '`Active` braintree teach.com.au subscription',
          hasExpiryDate: true,
          showExpiryDate: false,
          hasNextPaymentDate: true,
          showNextPaymentDate: true,
          showAmount: true,
          showPaymentMethod: true,
          actions: [
            {
              action: SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD,
              contactCS: false,
            },
            {
              action: SUBSCRIPTION_PLAN_ACTION_CANCEL,
              contactCS: true,
            },
          ],
        },
      },
      [SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING]: {
        [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
          description:
            'teach.com.au subscription marked for cancellation at the end of current billing cycle; can only be cancelled by CS via braintree',
          hasExpiryDate: true,
          showExpiryDate: true,
          hasNextPaymentDate: false,
          showNextPaymentDate: false,
          showAmount: false,
          showPaymentMethod: false,
          actions: [
            {
              action: SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_TEACHCOMAU,
              contactCS: false,
            },
          ],
        },
      },
      [SUBSCRIPTION_PLAN_STATUS_CANCELLED]: {
        [SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE]: {
          description: '`Canceled` braintree teach.com.au subscription',
          hasExpiryDate: true,
          showExpiryDate: true,
          hasNextPaymentDate: false,
          showNextPaymentDate: false,
          showAmount: false,
          showPaymentMethod: false,
          actions: [
            {
              action: SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_TEACHCOMAU,
              contactCS: false,
            },
          ],
        },
      },
    },
  },
});

export const userId = 'fake-user-id';
export const EDUCATOR_TRIAL_ID = 'educator-trial';
export const ACTIVE_INVOICED_EDUCATOR_ID = 'invoiced-educator-subscription';
export const ACTIVE_BRAINTREE_EDUCATOR_ID = 'braintree-educator-subscription';
export const PAST_DUE_BRAINTREE_EDUCATOR_ID = 'past_due-educator-subscription';
export const CANCEL_PENDING_BRAINTREE_EDUCATOR_ID =
  'cancel_pending-educator-subscription';
export const CANCELLED_BRAINTREE_EDUCATOR_ID =
  'cancelled-educator-subscription';
export const EXPIRED_EDUCATOR_TRIAL_ID = 'expired-educator-trial';
export const ACTIVE_BRAINTREE_TEACHCOMAU_ID = 'teachcomau-subscription';
export const CANCEL_PENDING_BRAINTREE_TEACHCOMAU_ID =
  'cancel_pending-teachcomau-subscription';
export const CANCELLED_BRAINTREE_TEACHCOMAU_ID =
  'cancelled-teachcomau-subscription';

export const EXPIRY_DATE_FUTURE = moment().add('20', 'days');
export const EXPIRY_DATE_PAST = moment().subtract('5', 'days');

export const validUserSubscriptionPlans = Immutable.fromJS([
  {
    description: 'Educator trial',
    id: EDUCATOR_TRIAL_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: null,
    status: SUBSCRIPTION_PLAN_STATUS_TRIAL,
    billingMethod: null,
    expiryDate: EXPIRY_DATE_FUTURE.toISOString(),
    nextPaymentDate: null,
  },
  {
    description: 'Manually invoiced educator subscription',
    id: ACTIVE_INVOICED_EDUCATOR_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: 'EDUCATOR_6MONTHS_AUD', // sometimes invoiced educator subscriptions don't have plan ids that match actual plans
    status: SUBSCRIPTION_PLAN_STATUS_ACTIVE,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_INVOICE,
    expiryDate: EXPIRY_DATE_FUTURE.toISOString(),
    nextPaymentDate: null,
  },
  {
    description: '`Active` braintree educator subscription',
    id: ACTIVE_BRAINTREE_EDUCATOR_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: 'EDUCATOR_YEARLY_AUD',
    status: SUBSCRIPTION_PLAN_STATUS_ACTIVE,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_FUTURE.toISOString(),
    nextPaymentDate: EXPIRY_DATE_FUTURE.toISOString(),
  },
  {
    description:
      '`Past Due` braintree educator subscription; Payment has been declined but subscription is still within Braintree recurring billing options automatic retry period of 7 days; It can take up to 3 days to retry a payment after the payment method has been updated.',
    id: PAST_DUE_BRAINTREE_EDUCATOR_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: 'EDUCATOR_MONTHLY_AUD',
    status: SUBSCRIPTION_PLAN_STATUS_PAST_DUE,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_PAST.toISOString(),
    nextPaymentDate: EXPIRY_DATE_PAST.toISOString(),
  },
  {
    description:
      'Educator subscription marked for cancellation at the end of current billing cycle; could have been cancelled by user or by CS via braintree',
    id: CANCEL_PENDING_BRAINTREE_EDUCATOR_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: 'EDUCATOR_MONTHLY_AUD',
    status: SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_FUTURE.toISOString(),
    nextPaymentDate: null,
  },
  {
    description: '`Canceled` braintree educator subscription',
    id: CANCELLED_BRAINTREE_EDUCATOR_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: 'EDUCATOR_MONTHLY_AUD',
    status: SUBSCRIPTION_PLAN_STATUS_CANCELLED,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_PAST.toISOString(),
    nextPaymentDate: null,
  },
  {
    description: 'Expired educator trial',
    id: EXPIRED_EDUCATOR_TRIAL_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_EDUCATOR,
    planId: null,
    status: SUBSCRIPTION_PLAN_STATUS_EXPIRED,
    billingMethod: null,
    expiryDate: EXPIRY_DATE_PAST.toISOString(),
    nextPaymentDate: null,
  },
  {
    description: '`Active` braintree teach.com.au subscription',
    id: ACTIVE_BRAINTREE_TEACHCOMAU_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_PORTAL,
    planId: 'TEACH_MONTHLY',
    status: SUBSCRIPTION_PLAN_STATUS_ACTIVE,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_FUTURE.toISOString(),
    nextPaymentDate: EXPIRY_DATE_FUTURE.toISOString(),
  },
  {
    description:
      'teach.com.au subscription marked for cancellation at the end of current billing cycle; can only be cancelled by CS via braintree',
    id: CANCEL_PENDING_BRAINTREE_TEACHCOMAU_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_PORTAL,
    planId: 'TEACH_MONTHLY',
    status: SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_FUTURE.toISOString(),
    nextPaymentDate: null,
  },
  {
    description: '`Canceled` braintree teach.com.au subscription',
    id: CANCELLED_BRAINTREE_TEACHCOMAU_ID,
    userId,
    type: SUBSCRIPTION_PLAN_TYPE_PORTAL,
    planId: 'TEACH_MONTHLY',
    status: SUBSCRIPTION_PLAN_STATUS_CANCELLED,
    billingMethod: SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE,
    expiryDate: EXPIRY_DATE_PAST.toISOString(),
    nextPaymentDate: null,
  },
]).reduce((subs, sub) => subs.set(sub.get('id'), sub), Immutable.OrderedMap());

export const audEducatorSubscriptionPlans = {
  EDUCATOR_MONTHLY_AUD: {
    planId: 'EDUCATOR_MONTHLY_AUD',
    path: '',
    price: 19.0,
    name: 'OpenLearning Educator Account',
    billingCycle: 'monthly',
    currency: 'AUD',
    type: 'educator',
  },
  EDUCATOR_YEARLY_AUD: {
    planId: 'EDUCATOR_YEARLY_AUD',
    path: '',
    price: 190.0,
    name: 'OpenLearning Educator Account',
    billingCycle: 'yearly',
    currency: 'AUD',
    type: 'educator',
  },
};

export const teachcomauSubscriptionPlans = {
  TEACH_MONTHLY: {
    planId: 'TEACH_MONTHLY',
    path: 'teachcomau',
    price: 29.0,
    name: 'Teach.com.au Account',
    billingCycle: 'monthly',
    currency: 'AUD',
    type: 'portal',
  },
};

export const testSubscriptionPlansState = {
  Auth: Immutable.fromJS({ currentUser: userId }),
  UserSubscriptionPlans: Immutable.Map({
    byUser: Immutable.Map({
      [userId]: Immutable.Map({
        plans: validUserSubscriptionPlans,
      }),
    }),
  }),
  SubscriptionPlans: Immutable.fromJS({
    ...audEducatorSubscriptionPlans,
    ...teachcomauSubscriptionPlans,
  }),
};

export const makeTestSubscriptionPlansState = (userSubscriptionPlan) => ({
  Auth: Immutable.fromJS({ currentUser: userId }),
  UserSubscriptionPlans: Immutable.Map({
    byUser: Immutable.Map({
      [userId]: Immutable.Map({
        plans: Immutable.Map({
          [userSubscriptionPlan.get('id')]: userSubscriptionPlan,
        }),
      }),
    }),
  }),
  SubscriptionPlans: Immutable.fromJS({
    ...audEducatorSubscriptionPlans,
    ...teachcomauSubscriptionPlans,
  }),
});
